
import { Tabs, TabPane } from "element-ui"
import {
  getUserNotificationCategoryList,
  getUserNotificationMsgList,
  clearNotificationUnread
} from "@/api/notification"
import pagination from "@/components/ware-view/pagination"
import notificationDetail from "@/components/drawer/notificationDetail.vue"
import notificationItem from "@/components/notificationCenter/notificationItem.vue"
import notificationEmpty from "@/components/notificationCenter/notificationEmpty.vue"

export default {
  name: "NotificationCenter",
  components: {
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane,
    pagination,
    notificationDetail,
    notificationItem,
    notificationEmpty
  },
  data() {
    return {
      tabs: [],
      activeTab: "0",
      list: [],
      lastPage: false,
      loading: true,
      pageInfo: {
        pageCount: 0,
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      detailVisible: false,
      msgId: ""
    }
  },
  mounted() {
    this.getCategoryList()
    this.getMsgList()
  },
  methods: {
    async getCategoryList() {
      const { data } = await getUserNotificationCategoryList()
      this.tabs = data || []
    },
    async getMsgList() {
      try {
        this.loading = true
        const params = {
          categoryId: Number(this.activeTab),
          currentPage: this.pageInfo.pageNum,
          pageSize: this.pageInfo.pageSize
        }
        const { data } = await getUserNotificationMsgList({ param: JSON.stringify(params) }, true)
        this.list = data?.result || []
        this.lastPage = data?.lastPage || false
        this.pageInfo = {
          pageCount: data?.pageCount || 0,
          pageNum: data?.currentPage || 1,
          pageSize: 10,
          total: data?.totalCount || 0
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    handlePageChange(value = 1) {
      this.pageInfo.pageNum = value
      this.getMsgList()
    },
    handleTabClick(tab) {
      this.handlePageChange()
    },
    async clearAllUnread() {
      const { data } = await clearNotificationUnread()
      if (data) {
        this.$message({
          message: this.$t("notification.markAllAsRead"),
          type: "success"
        })
        this.getCategoryList()
        this.getMsgList()
        this.$bus.$emit("getUnreadFlag")
      }
    },
    // 消息已读后还在当前页面时：刷新分类是否全部已读
    handleMarkAsRead(item) {
      this.getCategoryList()
    },
    learnMore(item) {
      if (!item.jumpUrl) {
        this.detailVisible = true
        this.msgId = item.msgId
      } else {
        window.location.href = `${this.MAIN_ORIGIN}${item.jumpUrl}`
      }
    },
    closeDrawer() {
      this.detailVisible = false
    }
  }
}
